import { Box, styled, Typography } from "@mui/material";

// Bottom action bar for the rule builder. Holds: Close, Active toggle, Test,
// Save Rule, plus rule-name + last-saved + unsaved indicator.
//
// Visual: thin top border, soft surface, generous left/right padding, gap
// between primary controls. Title bar at bottom is now redundant with the
// new <PageHeader> (which surfaces the rule name in the global app bar) —
// but kept here for now until that integration is fully verified.
export const RuleFooterContainer = styled(Box)(({ theme }) => ({
	position: "relative",
	display: "flex",
	alignItems: "center",
	gap: theme.spacing(1.5),
	padding: theme.spacing(1.5, 2.5),
	borderTop: "1px solid rgba(13, 31, 48, 0.08)",
	background: "#FFFFFF",
	borderBottomLeftRadius: 12,
	borderBottomRightRadius: 12,
	boxShadow: "0 -4px 12px rgba(13, 31, 48, 0.04)",
	flexWrap: "wrap",
	[theme.breakpoints.down("sm")]: {
		padding: theme.spacing(1.25, 1.5),
	},
}));

export const RuleTitleContainer = styled(Box)(({ theme }) => ({
	position: "absolute",
	// Stretch the absolute box to the FULL footer height (top:0 → bottom:0) and
	// center the name with flex alignItems — this vertically centers reliably
	// regardless of the footer's height or the text's own line-height (the prior
	// top:50% + translateY approach left it sitting low).
	top: 0,
	bottom: 0,
	left: "50%",
	transform: "translateX(-50%)",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	gap: theme.spacing(0.75),
	maxWidth: "40%",
	color: "rgba(13, 31, 48, 0.55)",
	"& .MuiTypography-root": {
		fontSize: 13,
		fontWeight: 500,
		letterSpacing: "0.01em"
	},
	"& .MuiIconButton-root": {
		opacity: 0.5,
		transition: "opacity 0.18s",
		"&:hover": { opacity: 1 }
	},
	[theme.breakpoints.down("sm")]: {
		position: "static",
		transform: "none",
		maxWidth: "100%",
		flexBasis: "100%",
		order: 2,
		justifyContent: "flex-start",
	},
}));

export const LastSavedText = styled(Typography)(() => ({
	marginLeft: "auto",
	color: "rgba(13, 31, 48, 0.45)",
	fontSize: 12,
	fontWeight: 500,
	letterSpacing: "0.01em",
	whiteSpace: "nowrap"
}));